"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ServiceOperationComponent = _interopRequireDefault(require("../../components/ServiceLogs/ServiceOperationComponent"));
var _images = _interopRequireDefault(require("../../common_features/assets/images"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _moment = _interopRequireDefault(require("moment"));
var _strings = require("../../common_features/utility/strings");
var _systemsReducer = require("../../common_features/redux/reducers/systemsReducer");
var _helper = require("../../common_features/utility/helper");
var _ToastContainer = require("@ccw-pwa-ui/ToastContainer");
var _Services = require("../../common_features/utility/Services");
var _reactResponsive = require("react-responsive");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ServiceOperations = () => {
  var _serviceLogs$, _serviceLogs$2, _serviceLogs$3, _serviceLogs$4, _serviceLogs$5, _serviceLogs$6, _serviceLogs$7, _serviceLogs$8, _serviceLogs$9, _serviceLogs$10, _serviceLogs$11, _serviceLogs$12, _serviceLogs$13, _serviceLogs$14, _serviceLogs$15, _serviceLogs$15$creat, _serviceLogs$16, _serviceLogs$16$creat, _serviceLogs$17, _serviceLogs$17$creat, _serviceLogs$18, _serviceLogs$18$creat, _serviceLogs$19, _response$, _response$$ServiceLog, _selectedSystems$Syst;
  const navigate = (0, _reactRouterDom.useNavigate)();
  const isDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: 992
  });
  const dispatch = (0, _reactRedux.useDispatch)();
  const [open, setOpen] = (0, _react.useState)(false);
  const [openIndex, setOpenIndex] = (0, _react.useState)([]);
  const [viewImage, setViewImage] = (0, _react.useState)(false);
  const [imgArray, setImgArray] = (0, _react.useState)([]);
  const [caption, setCaption] = (0, _react.useState)("");
  const [currentNotes, setCurrentNotes] = (0, _react.useState)("");
  const [notesId, setNoteId] = (0, _react.useState)("");
  const [response, setResponse] = (0, _react.useState)({});
  const [notesText, setNotesText] = (0, _react.useState)('');
  const [editClicked, setEditClicked] = (0, _react.useState)(false);
  const [logHeader, setLogHeader] = (0, _react.useState)("");
  const [isOpenWaterInfo, setIsOpenWaterInfo] = (0, _react.useState)(false);
  const [isLoading, setLoading] = (0, _react.useState)(false);
  const [imageUrl, setImageUrl] = (0, _react.useState)([]);
  const [selectedImage, setSelectedImage] = (0, _react.useState)(imageUrl[0]);
  const [editVisible, setEditVisible] = (0, _react.useState)(true);
  const [reading, setReading] = (0, _react.useState)([]);
  const [charCount, setCharCount] = (0, _react.useState)(250);
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  let personaDetails = {};
  let fetchedData = response;
  (0, _helper.getUserTypeForDispatcherLayout)(userInfo, personaDetails);
  (0, _helper.getPersonaName)(userInfo, personaDetails);
  const {
    selectedSystems,
    serviceLogs,
    serviceHistoryDetails
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const systemDetailClick = async index => {
    if (open) {
      const removedArray = openIndex.filter(item => item === index);
      setOpenIndex(removedArray);
      setOpenIndex(prev => [...prev, index]);
      await getData(index);
    }
    if (!open) {
      let removedArray = openIndex.filter(item => item !== index);
      setOpenIndex(removedArray);
    }
    setOpen(!open);
  };
  const handleImageClick = (image, index) => {
    var _serviceHistoryDetail, _serviceHistoryDetail2;
    const getCaption = serviceHistoryDetails === null || serviceHistoryDetails === void 0 ? void 0 : (_serviceHistoryDetail = serviceHistoryDetails.data[0]) === null || _serviceHistoryDetail === void 0 ? void 0 : (_serviceHistoryDetail2 = _serviceHistoryDetail.ServiceLogImageUrls) === null || _serviceHistoryDetail2 === void 0 ? void 0 : _serviceHistoryDetail2.map(item => item === null || item === void 0 ? void 0 : item.imageDescription);
    setCaption(getCaption[index]);
    setSelectedImage(image);
  };
  const onBackPress = () => {
    navigate(-1);
  };
  const crossIconAction = () => {
    setViewImage(false);
  };
  const b64toBlob = function (b64Data) {
    let contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    let sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: contentType
    });
    return blob;
  };
  const fetchImage = async (images, index) => {
    var _images$index;
    let result = [];
    index = index ? index : 0;
    const currentSelectedImage = (_images$index = images[index]) === null || _images$index === void 0 ? void 0 : _images$index.map(item => item === null || item === void 0 ? void 0 : item.imageUrl);
    try {
      await Promise.all(currentSelectedImage.length ? currentSelectedImage === null || currentSelectedImage === void 0 ? void 0 : currentSelectedImage.map(async imgPath => {
        const resp = await (0, _Services.imageGet)(imgPath);
        setLoading(false);
        const blobData = b64toBlob(atob(resp).split(",")[1].slice(0, -1));
        result.push(blobData);
        const imgArray = result.map(file => {
          return URL.createObjectURL(file);
        });
        setImageUrl(imgArray);
      }) : setImageUrl([]));
    } catch (error) {
      setLoading(false);
      console.log(error, "fetchImage api error");
    }
  };
  const getData = async index => {
    var _data$data, _data$data2, _data$data3, _data$data3$data, _data$data4, _data$data4$data$, _data$data4$data$$Ser, _data$data5, _data$data5$data, _data$data5$data$map$, _data$data6, _data$data6$data$, _data$data6$data$$Ser, _data$data7, _data$data7$data;
    setLoading(true);
    const systemId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId;
    const storeId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.storeId;
    const orgId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId;
    const serviceId = serviceLogs === null || serviceLogs === void 0 ? void 0 : serviceLogs.map(item => item === null || item === void 0 ? void 0 : item.serviceId);
    const data = await (0, _Services.getHistoryRecords)(storeId, orgId, systemId, serviceId);
    fetchedData = data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data;
    setResponse(data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.data);
    dispatch((0, _systemsReducer.serviceHistory)(data === null || data === void 0 ? void 0 : data.data));
    const getImage = data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : (_data$data3$data = _data$data3.data) === null || _data$data3$data === void 0 ? void 0 : _data$data3$data.map(item => item === null || item === void 0 ? void 0 : item.ServiceLogImageUrls);
    fetchImage(getImage, index);
    const infoValue = data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : (_data$data4$data$ = _data$data4.data[0]) === null || _data$data4$data$ === void 0 ? void 0 : (_data$data4$data$$Ser = _data$data4$data$.ServiceLogReadings[0]) === null || _data$data4$data$$Ser === void 0 ? void 0 : _data$data4$data$$Ser.readings;
    const readingValue = (0, _helper.waterInfoMap)(infoValue);
    setReading([...readingValue.keys()]);
    const dateTwo = new Date(new Date(fetchedData[0].createdAt).getTime());
    const today = new Date(Date.now());
    const dateValue = (0, _helper.formatDateString)(new Date(dateTwo));
    setEditVisible(dateValue === (0, _helper.formatDateString)(today));
    setCaption(data === null || data === void 0 ? void 0 : (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : (_data$data5$data = _data$data5.data) === null || _data$data5$data === void 0 ? void 0 : (_data$data5$data$map$ = _data$data5$data.map(item => item === null || item === void 0 ? void 0 : item.ServiceLogImageUrls)[0]) === null || _data$data5$data$map$ === void 0 ? void 0 : _data$data5$data$map$.map(item => item === null || item === void 0 ? void 0 : item.imageDescription)[0]);
    setNotesText(data === null || data === void 0 ? void 0 : (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : (_data$data6$data$ = _data$data6.data[0]) === null || _data$data6$data$ === void 0 ? void 0 : (_data$data6$data$$Ser = _data$data6$data$.ServiceLogNotes[0]) === null || _data$data6$data$$Ser === void 0 ? void 0 : _data$data6$data$$Ser.note);
    setNoteId(data === null || data === void 0 ? void 0 : (_data$data7 = data.data) === null || _data$data7 === void 0 ? void 0 : (_data$data7$data = _data$data7.data) === null || _data$data7$data === void 0 ? void 0 : _data$data7$data.map(note => {
      var _note$ServiceLogNotes;
      return (_note$ServiceLogNotes = note.ServiceLogNotes[0]) === null || _note$ServiceLogNotes === void 0 ? void 0 : _note$ServiceLogNotes.noteId;
    }));
    setLoading(false);
  };
  (0, _react.useEffect)(() => {
    getData();
  }, []);
  (0, _react.useEffect)(() => {
    logHeaderValue();
  }, [imgArray]);
  const waterInfoClick = () => {
    setIsOpenWaterInfo(!isOpenWaterInfo);
  };
  const viewImageClick = () => {
    setViewImage(true);
  };
  const onChangeNotes = e => {
    const inputVal = e.target.value;
    if ((inputVal === null || inputVal === void 0 ? void 0 : inputVal.length) <= 250) {
      setCurrentNotes(inputVal);
      setCharCount(250 - (inputVal === null || inputVal === void 0 ? void 0 : inputVal.length));
    }
  };
  const getImageArray = item => {
    const serviceLogImage = [];
    if (item && serviceLogs[0].serviceLogsType === ('6' || '4')) {
      for (let i = 0; i < item.length; i++) {
        serviceLogImage.push({
          imageUrl: item[i].imageUrl,
          imageDescription: item[i].imageDescription
        });
      }
    }
    return serviceLogImage;
  };
  const saveContinueBtnClick = async index => {
    var _response$index, _response$index$Syste, _response$index2, _response$index2$Syst, _response$index3, _response$index3$Syst, _response$index4, _response$index4$Syst, _response$index5, _response$index$store, _response$index6, _response$index7, _response$index7$Serv;
    setNotesText(currentNotes);
    const systemId = serviceLogs === null || serviceLogs === void 0 ? void 0 : serviceLogs.map(item => item === null || item === void 0 ? void 0 : item.systemId);
    const storeId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.storeId;
    const orgId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId;
    setLoading(true);
    const systemReferences = [{
      "refAppId": (_response$index = response[index]) === null || _response$index === void 0 ? void 0 : (_response$index$Syste = _response$index.SystemReferenceMapping) === null || _response$index$Syste === void 0 ? void 0 : _response$index$Syste.refAppId,
      "refAppInstallationDate": (_response$index2 = response[index]) === null || _response$index2 === void 0 ? void 0 : (_response$index2$Syst = _response$index2.SystemReferenceMapping) === null || _response$index2$Syst === void 0 ? void 0 : _response$index2$Syst.refAppInstallationDate,
      "refAppName": (_response$index3 = response[index]) === null || _response$index3 === void 0 ? void 0 : (_response$index3$Syst = _response$index3.SystemReferenceMapping) === null || _response$index3$Syst === void 0 ? void 0 : _response$index3$Syst.refAppName,
      "refAppType": (_response$index4 = response[index]) === null || _response$index4 === void 0 ? void 0 : (_response$index4$Syst = _response$index4.SystemReferenceMapping) === null || _response$index4$Syst === void 0 ? void 0 : _response$index4$Syst.refAppType,
      "ServiceLogNote": {
        "note": currentNotes ? currentNotes : notesText
      },
      "ServiceLogImageUrls": await getImageArray((_response$index5 = response[index]) === null || _response$index5 === void 0 ? void 0 : _response$index5.ServiceLogImageUrls)
    }];
    let payload = {
      "systemId": systemId[index],
      "storeId": storeId,
      "orgId": orgId,
      "installedDate": serviceLogs[0].serviceLogsType === "2" ? selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.installedDate : null,
      "waterDest": serviceLogs[0].serviceLogsType === "3" ? (_response$index$store = response[index].store_system_mappings_model) === null || _response$index$store === void 0 ? void 0 : _response$index$store.waterDest : null,
      "ServiceLogNote": serviceLogs[0].serviceLogsType !== ('6' || '4') && currentNotes ? {
        "note": currentNotes
      } : null,
      "ServiceLogImageUrls": serviceLogs[0].serviceLogsType === ('2' || '3' || '8') ? (_response$index6 = response[index]) === null || _response$index6 === void 0 ? void 0 : _response$index6.ServiceLogImageUrls : null,
      "systemReferences": serviceLogs[0].serviceLogsType === ('6' || '4') ? systemReferences : null,
      "ServiceLogReading": serviceLogs[0].serviceLogsType === '7' ? {
        "readings": (_response$index7 = response[index]) === null || _response$index7 === void 0 ? void 0 : (_response$index7$Serv = _response$index7.ServiceLogReadings[0]) === null || _response$index7$Serv === void 0 ? void 0 : _response$index7$Serv.readings
      } : null
    };
    payload = Object.entries(payload).reduce((data, _ref) => {
      let [k, v] = _ref;
      return v == null ? data : (data[k] = v, data);
    }, {});
    await (0, _Services.updateSystem)(payload);
    setLoading(false);
    setEditClicked(false);
    _ToastContainer.CustomToast.success("Notes has been updated successfully.", "success");
  };
  const onEditClick = () => {
    setEditClicked(true);
  };
  const onCancleBtnClick = () => {
    setEditClicked(false);
  };
  const logHeaderValue = () => {
    if (_strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[5]) {
      setLogHeader("Accessories added");
    } else if (_strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[6]) {
      setLogHeader("Accessories Updated");
    } else if (_strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[7]) {
      setLogHeader("Water Info Logs");
    } else if (_strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[2]) {
      setLogHeader("System Updated");
    } else if (_strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[3]) {
      setLogHeader("Water Destination Logs");
    } else if (_strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[4]) {
      setLogHeader("Filter Updated");
    } else {
      setLogHeader("");
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ServiceOperationComponent.default, {
    navHeading: "Service History",
    handleBack: onBackPress,
    leftArrowImage: _images.default.leftArrow.default,
    headerText: _strings.serviceLogType[serviceLogs[0].serviceLogsType],
    isImageVisible: _strings.serviceLogType[(_serviceLogs$ = serviceLogs[0]) === null || _serviceLogs$ === void 0 ? void 0 : _serviceLogs$.serviceLogsType] === _strings.serviceLogType[1] || _strings.serviceLogType[(_serviceLogs$2 = serviceLogs[0]) === null || _serviceLogs$2 === void 0 ? void 0 : _serviceLogs$2.serviceLogsType] === _strings.serviceLogType[2] || _strings.serviceLogType[(_serviceLogs$3 = serviceLogs[0]) === null || _serviceLogs$3 === void 0 ? void 0 : _serviceLogs$3.serviceLogsType] === _strings.serviceLogType[6] || _strings.serviceLogType[(_serviceLogs$4 = serviceLogs[0]) === null || _serviceLogs$4 === void 0 ? void 0 : _serviceLogs$4.serviceLogsType] === _strings.serviceLogType[5] || _strings.serviceLogType[(_serviceLogs$5 = serviceLogs[0]) === null || _serviceLogs$5 === void 0 ? void 0 : _serviceLogs$5.serviceLogsType] === _strings.serviceLogType[8] || _strings.serviceLogType[(_serviceLogs$6 = serviceLogs[0]) === null || _serviceLogs$6 === void 0 ? void 0 : _serviceLogs$6.serviceLogsType] === _strings.serviceLogType[4],
    isWaterInfoVisible: _strings.serviceLogType[(_serviceLogs$7 = serviceLogs[0]) === null || _serviceLogs$7 === void 0 ? void 0 : _serviceLogs$7.serviceLogsType] === _strings.serviceLogType[1],
    notesNotVisible: _strings.serviceLogType[(_serviceLogs$8 = serviceLogs[0]) === null || _serviceLogs$8 === void 0 ? void 0 : _serviceLogs$8.serviceLogsType] === _strings.serviceLogType[8],
    timelineNotVisible: _strings.serviceLogType[(_serviceLogs$9 = serviceLogs[0]) === null || _serviceLogs$9 === void 0 ? void 0 : _serviceLogs$9.serviceLogsType] === _strings.serviceLogType[8] || _strings.serviceLogType[(_serviceLogs$10 = serviceLogs[0]) === null || _serviceLogs$10 === void 0 ? void 0 : _serviceLogs$10.serviceLogsType] === _strings.serviceLogType[2] || _strings.serviceLogType[(_serviceLogs$11 = serviceLogs[0]) === null || _serviceLogs$11 === void 0 ? void 0 : _serviceLogs$11.serviceLogsType] === _strings.serviceLogType[3] || _strings.serviceLogType[(_serviceLogs$12 = serviceLogs[0]) === null || _serviceLogs$12 === void 0 ? void 0 : _serviceLogs$12.serviceLogsType] === _strings.serviceLogType[7] || _strings.serviceLogType[(_serviceLogs$13 = serviceLogs[0]) === null || _serviceLogs$13 === void 0 ? void 0 : _serviceLogs$13.serviceLogsType] === _strings.serviceLogType[1],
    logHeader: logHeader,
    systemNameKey: "System Name",
    systemModelValue: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber,
    systemNameValue: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber,
    installDateKey: "Installation Date",
    installDateValue: (0, _moment.default)(new Date(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.installedDate)).format('MMM DD, YYYY'),
    lastServiceLogDateKey: "Last Service Log Date",
    lastServiceLogDateValue: (0, _moment.default)(new Date((_serviceLogs$14 = serviceLogs[0]) === null || _serviceLogs$14 === void 0 ? void 0 : _serviceLogs$14.onDate)).format('MMM DD, YYYY'),
    updatedByKey: "Updated By",
    updatedByValue: "".concat(((_serviceLogs$15 = serviceLogs[0]) === null || _serviceLogs$15 === void 0 ? void 0 : (_serviceLogs$15$creat = _serviceLogs$15.createdBy) === null || _serviceLogs$15$creat === void 0 ? void 0 : _serviceLogs$15$creat.userType) === "dispatcher" ? " Dispatcher: " : " Technician: ").concat(" " + ((_serviceLogs$16 = serviceLogs[0]) === null || _serviceLogs$16 === void 0 ? void 0 : (_serviceLogs$16$creat = _serviceLogs$16.createdBy) === null || _serviceLogs$16$creat === void 0 ? void 0 : _serviceLogs$16$creat.firstName) + " " + ((_serviceLogs$17 = serviceLogs[0]) === null || _serviceLogs$17 === void 0 ? void 0 : (_serviceLogs$17$creat = _serviceLogs$17.createdBy) === null || _serviceLogs$17$creat === void 0 ? void 0 : _serviceLogs$17$creat.lastName)),
    serviceProvNameKey: "Service Provider",
    serviceProvNameValue: (_serviceLogs$18 = serviceLogs[0]) === null || _serviceLogs$18 === void 0 ? void 0 : (_serviceLogs$18$creat = _serviceLogs$18.createdBy) === null || _serviceLogs$18$creat === void 0 ? void 0 : _serviceLogs$18$creat.serviceProviderOrgName,
    systemDetail: "System Detail",
    systemDetailVisible: _strings.serviceLogType[(_serviceLogs$19 = serviceLogs[0]) === null || _serviceLogs$19 === void 0 ? void 0 : _serviceLogs$19.serviceLogsType] === _strings.serviceLogType[1],
    arrowIcon: open ? _images.default.arrowUp.default : _images.default.arrowDown.default,
    waterInfoRightIcon: isOpenWaterInfo ? _images.default.arrowUp.default : _images.default.arrowDown.default,
    systemDetailClick: systemDetailClick,
    isOpenSysDetail: open,
    waterInfo: "Water Info",
    isOpenWaterInfo: isOpenWaterInfo,
    waterInfoClick: waterInfoClick,
    notes: "Notes",
    readingsKey: reading,
    readings: (_response$ = response[0]) === null || _response$ === void 0 ? void 0 : (_response$$ServiceLog = _response$.ServiceLogReadings[0]) === null || _response$$ServiceLog === void 0 ? void 0 : _response$$ServiceLog.readings,
    notesText: notesText,
    photo: "Photos",
    image: imageUrl,
    viewImageClick: viewImageClick,
    viewImage: viewImage,
    isLoading: isLoading,
    zoomCarousel: imageUrl,
    successModaldata: selectedSystems,
    crossIconAction: crossIconAction,
    selectedImage: selectedImage || imageUrl[0],
    caption: caption,
    handleImageClick: handleImageClick,
    imageListStyle: "image-list",
    editImage: _images.default.EditPencil.default,
    onEditClick: onEditClick,
    editClicked: editClicked,
    onChangeNotes: onChangeNotes,
    onCancleBtnClick: onCancleBtnClick,
    saveContinueBtnClick: saveContinueBtnClick,
    isAccessoryPresent: selectedSystems !== null && selectedSystems !== void 0 && (_selectedSystems$Syst = selectedSystems.SystemReferenceMappings) !== null && _selectedSystems$Syst !== void 0 && _selectedSystems$Syst.filter(item => item.refAppType === "Accessory").length ? true : false,
    timelineData: serviceLogs,
    imageModalStyle: isDesktop ? {
      width: "821px",
      cursor: "pointer",
      marginTop: "-50px",
      marginRight: "50px",
      marginLeft: "-150px"
    } : {
      width: "336px",
      height: "245px",
      marginTop: "-50px",
      marginLeft: "25px",
      cursor: "pointer",
      transform: 'translateY(10px)',
      paddingLeft: '10px'
    },
    captionContainer: {
      width: "336px",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      height: "245px"
    },
    selectedImageStyle: caption ? isDesktop ? {
      width: "740px",
      marginTop: "-250px",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      height: "533px",
      overflow: "hidden",
      objectFit: 'contain',
      background: 'black'
    } : {
      width: "336px",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      height: "245px",
      maxWidth: '90%',
      objectFit: 'contain',
      background: 'black'
    } : isDesktop ? {
      width: "740px",
      marginTop: "-250px",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      height: "533px",
      overflow: "hidden",
      objectFit: 'contain',
      background: 'black'
    } : {
      width: "336px",
      borderRadius: "10px",
      height: "245px",
      maxWidth: '90%',
      objectFit: 'contain',
      background: 'black'
    },
    scrollableItem: {
      marginBottom: "10px"
    },
    unselectedImage: {
      width: "99px",
      height: "73px",
      marginTop: "25px",
      marginRight: "5px",
      opacity: 0.7,
      borderRadius: "7px",
      backgroundColor: "rgba(255,255,255,.5)"
    },
    wrapperStyle: {
      borderRadius: "12px 12px 12px 12px",
      bottom: "70%"
    },
    imageVariant: "image-carousel",
    EditText: "Edit",
    historyVisible: _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[5] || _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[4] || _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[6] ? false : true,
    logVisible: _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[3] || _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[7] || _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[8] || _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[2],
    accessoryAdded: _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[5],
    openIndex: openIndex,
    systemData: (0, _helper.groupLogs)(serviceHistoryDetails === null || serviceHistoryDetails === void 0 ? void 0 : serviceHistoryDetails.data),
    listData: (0, _helper.groupData)(serviceHistoryDetails === null || serviceHistoryDetails === void 0 ? void 0 : serviceHistoryDetails.data),
    noPhoto: _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[3] || _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[7] || _strings.serviceLogType[serviceLogs[0].serviceLogsType] === _strings.serviceLogType[2],
    dispatcher: editVisible ? (personaDetails.personaName === 'Dispatcher' || personaDetails.personaName === 'Technician') && _strings.serviceLogType[serviceLogs[0].serviceLogsType] !== _strings.serviceLogType[1] && _strings.serviceLogType[serviceLogs[0].serviceLogsType] !== _strings.serviceLogType[5] ? true : false : false,
    maxLengthText: (notesText === null || notesText === void 0 ? void 0 : notesText.length) === 0 ? "Maximum character limit : 250" : "You have ".concat(250 - (notesText === null || notesText === void 0 ? void 0 : notesText.length), " characters remaining")
  }));
};
var _default = exports.default = ServiceOperations;